import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#f8721e',
      contrastText: '#ffebee',
    },
  },
});
